import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useAuth } from '../contexts/auth-context';

function Index() {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/home" />;
  }

  return <Navigate to="/login" />;
}

export const Route = createFileRoute('/')({
  component: Index,
});
